import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=f2dcc82e&scoped=true"
import script from "./orderInvoice.vue?vue&type=script&lang=js"
export * from "./orderInvoice.vue?vue&type=script&lang=js"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=f2dcc82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dcc82e",
  null
  
)

export default component.exports